module.exports = __webpack_public_path__ + "static/media/wifi-poster.bd3e2dda.png";